import { Paper } from "@commonlibs";
import styled, { css } from "styled-components";

export const OutlinedCardRoot = styled(Paper)(({ theme }) => {
    return css`
        background: ${theme.palette.components.card.background};
        border-radius: ${theme.borderRadius};
        border: ${theme.border.sm};
    `;
});
